import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"

type Props = {
    text?: string
}

export const FullScreenLoading = ({ text }: Props) => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                bgcolor: 'white',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Stack spacing={2} direction="column" alignItems="center">
                <StaticImage quality={80} placeholder="none" alt="Blootropic logo" src={'../../assets/img/logo-colored-seo-logoicon.png'} width={200} height={200} />
                <CircularProgress size={60} />
                {text && <Typography variant="h4">{text}</Typography>}
            </Stack>
        </Box>
    )
}